"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter, useSearchParams } from "next/navigation";
import { useCallback, useTransition } from "react";
export function useFilterQuery() {
  const $ = _c(6);
  const router = useRouter();
  const params = useSearchParams();
  const [isPending, startTransition] = useTransition();
  let t0;
  if ($[0] !== params || $[1] !== router) {
    t0 = (key, value) => {
      const newParams = new URLSearchParams(params.toString());
      if (!value || Array.isArray(value) && value.length === 0) {
        newParams.delete(key);
      } else {
        if (Array.isArray(value)) {
          newParams.set(key, value.join(","));
        } else {
          newParams.set(key, value);
        }
      }
      startTransition(() => {
        router.replace(`?${newParams.toString()}`, {
          scroll: false
        });
      });
    };
    $[0] = params;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const updateQuery = t0;
  let t1;
  if ($[3] !== isPending || $[4] !== updateQuery) {
    t1 = {
      updateQuery,
      isPending
    };
    $[3] = isPending;
    $[4] = updateQuery;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}